import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { DEFAULT_SETTINGS, fetchSettings } from "@/lib/api";
import { trackVisit } from "@/lib/track";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Bento } from "@/components/site/Bento";
import { Steps } from "@/components/site/Steps";
import { Pricing } from "@/components/site/Pricing";
import { Testimonials } from "@/components/site/Testimonials";
import { Support } from "@/components/site/Support";
import { FinalCta, Footer } from "@/components/site/Footer";

export default function Home() {
  const { data } = useQuery({ queryKey: ["settings"], queryFn: fetchSettings });
  const s = data || DEFAULT_SETTINGS;
  useEffect(() => {
    trackVisit();
  }, []);
  return (
    <main className="min-h-screen overflow-x-clip bg-white" data-testid="home-page">
      <SmoothScroll />
      <Nav s={s} />
      <Hero s={s} />
      <Marquee />
      <Bento />
      <Steps />
      <Testimonials s={s} />
      <Pricing s={s} />
      <Support s={s} />
      <FinalCta s={s} />
      <Footer />
    </main>
  );
}
